export default function Logo({ dark = false, className = "" }) {
  const text = dark ? "#FBF9F5" : "#1A1D20";
  const sub = dark ? "rgba(251,249,245,0.55)" : "#5A6065";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/logo.jpg"
        alt="ArcView Homes logo"
        className="h-11 w-11 rounded-full object-cover flex-shrink-0"
        width="44"
        height="44"
      />
      <span className="flex flex-col leading-none">
        <span className="font-serif text-[22px] font-medium tracking-tight" style={{ color: text }}>
          ArcView <span className="italic">Homes</span>
        </span>
        <span className="font-mono text-[8.5px] tracking-[0.42em] uppercase mt-1" style={{ color: sub }}>
          Design · Build · Tarneit
        </span>
      </span>
    </span>
  );
}
